import React, { useState, useEffect, useRef } from "react";
import Back from '../../../Components/back/back';
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { FaPlus, FaTrash } from 'react-icons/fa'; // Import the plus icon from react-icons
import Writing from '../../../Components/typewriter/typewriter';
import "react-phone-number-input/style.css";
import '../../../css/loader.css';
import config from '../../../Context/Config';
import logo from '../../../Components/Assets/logo.svg'
import segLogo from "../../../Components/Assets/seg-logo.png";
import Rocket from '../../../Components/rocket/rocket';
import NextBtnLoader from "../../../Components/loader/loader";
import FormInput from "../../../Components/formInput/formInput";
import DobInput from "../../../Components/dobPicker/dobInput";
import SelectInput from "../../../Components/selectInput/select";
import TextInput from "../../../Components/textInput/textInput";
import BackgruseRedirectIfNotLoggedIn from '../../../Components/redirect/redirect';
import { checkTokenAndNavigate } from "../../../Utils/login";
import { getCityStateFromZip } from "../../../Utils/zip";
import { showAlertAndNavigate } from "../../../Utils/swal";
import MedicalPortalAccess from "../../../Components/selectInput/portal";
import DynamicCheckbox from "../../../Components/selectInput/consent";
import { languageOptions, genderOptions, emergencyRelationshipOptions, ethnicityOptions, raceOptions } from '../../../Utils/Options'
import { handleFamilyContentChanges } from "../../../Utils/familyMembers";
import Paragraph from "../../../Components/paragraph/paragrah";
import Logo from '../../../Components/InfoDisplay/logo';
import Head from '../../../Components/InfoDisplay/header';

const PatientRegistrationPageForm = () => {
    const [nextLoader, setNextLoader] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const location = useLocation();
    const { openedViaLogin } = location.state || {};
    BackgruseRedirectIfNotLoggedIn(openedViaLogin, 10, "/context-not-found");
    const navigate = useNavigate();
    const [pageTitle, setPageTitle] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading4, setIsLoading4] = useState(false);
    const taskRunRef = useRef(false);
    const [fileUpload, setFileUpload] = useState(false);
    const [PatientRegistrationFormData, setPatientRegistrationFormData] = useState({
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        ssn: "",
        gender: "",
        dob: "",
        email: "",
        cellphone: "",
        language: "",
        race: "",
        ethnicity: "",
        referredBy: "",
        familyDoctor: "",
        emergencyName: "",
        emergencyRelationship: "",
        emergencyPhone: "",
        consentToText: false,
        familyMembers: [
            { name: '', relationship: '', dob: '', mobile_number: '' },
        ],
        portal: null,
        originalPortal: null
    });
    const [invalidFields, setInvalidFields] = useState([]);

    const handleZipSearch = async () => {
        const zip = PatientRegistrationFormData.zip;
        const result = await getCityStateFromZip(zip);
        if (result) {
            setPatientRegistrationFormData({
                ...PatientRegistrationFormData,
                city: result.city,
                state: result.state,
            });
        } else {
            setPatientRegistrationFormData({
                ...PatientRegistrationFormData,
                city: '',
                state: '',
            });
        }
    }

    // Function to handle API call
    const runTask = async () => {
        setIsLoading4(true);
        if (taskRunRef.current) return; // Prevent running if task has already been executed
        taskRunRef.current = true;

        try {
            const response = await fetch(`${config.API_BASE_URL}/token_pat_data`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    Authorization: config.accessToken || "",
                }
            });
            if (response.ok) {
                let data = await response.json();

                setPatientRegistrationFormData(prevState => ({
                    ...prevState, // Retain existing fields
                    firstName: data['firstname'] || "",
                    lastName: data['lastname'] || "",
                    address: data['address1'] || "",
                    gender: data['sex'] || "",
                    zip: data['zip'] || "",
                    city: data['city'] || "",
                    state: data['state'] || "",
                    cellphone: (data['mobilephone'] || "").toString().trim(),
                    language: data['language6392code'] || "",
                    email: data['email'] || "",
                    race: data?.race?.[0] || "",
                    emergencyName: data['contactname'] || "",
                    emergencyRelationship: data['contactrelationship'] || "",
                    emergencyPhone: (data['contactmobilephone'] || "").toString().trim(),
                    ssn: data['ssn'] || "",
                    portal: data['portalstatus']['registered'] || "",
                    originalPortal: data['portalstatus']['registered'] || "",
                    referredBy: data.db_data?.referred_by ?? "",
                    familyDoctor: data.db_data?.family_doctor ?? "",
                    dob: data['dob'] || prevState.dob, // Preserve existing value if not in `data`
                    ethnicity: (data?.ethnicitycodes?.[0]) || prevState.ethnicity,
                    familyMembers: data['family_data'] || prevState.familyMembers,
                    consentToText: data['consenttotext'] || prevState.consentToText
                }));

            } else {
                // Handle different error scenarios
                showAlertAndNavigate(
                    "warning",
                    "Unauthorized",
                    "Your session expired. Redirecting to login...",
                    config.token
                );

            }
        } finally {
            // Reset loading state
            setIsLoading4(false);
        }
    };

    useEffect(() => {
        if (openedViaLogin && !taskRunRef.current) {
            checkTokenAndNavigate(runTask, navigate);
        }
    }, [openedViaLogin]);

    const handlePortalChange = (e) => {
        const { id, value } = e.target;

        setPatientRegistrationFormData((prev) => ({
            ...prev,
            [id]: id === "portal" ? value === "true" : value,
        }));
    };

    const handleFamilyContentChange = (index, field, value) => {

        handleFamilyContentChanges({
            index,
            field,
            value,
            formData: PatientRegistrationFormData,
            setFormData: setPatientRegistrationFormData,
        });
    };

    const isFamilyMemberEmpty = (member) => {
        if (!member) return true;
        const { name, relationship, dob, mobile_number } = member;
        return [name, relationship, dob, mobile_number].every(
            (value) => !value || value.toString().trim() === ""
        );
    };

    const validateFamilyMembers = (familyMembers) => {
        const isValidPhone = (value, country = "US") => {
            const parsed = parsePhoneNumberFromString(value, country);
            return parsed?.isValid() || false;
        };
        const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
        let msg = "";
        // If only one family member, check separately
        if (familyMembers.length === 1) {
            const member = familyMembers[0];

            const allEmpty = Object.values(member).every(
                (value) => !value?.toString().trim()
            );
            if (allEmpty) {
                return;
            }
            const isDobValid = dobRegex.test(member.dob) && new Date(member.dob) <= new Date();


            // Validate missing values (excluding phone)
            if (
                Object.entries(member).some(
                    ([key, value]) =>
                        key !== "mobile_number" &&
                        (value === null ||
                            value === undefined ||
                            value.toString().trim() === "")
                )
            ) {
                msg += `Missing values in family member: ${JSON.stringify(member)}. `;


            }
            if (!isDobValid) {
                msg += "Invalid DOB format. Please use MM/DD/YYYY.\n";
            }
            // Validate phone number separately
            if (!isValidPhone(member.mobile_number)) {
                msg = `Invalid phone number. ` + msg;
            }

            return msg || null; // Return message if there's an error, otherwise return null
        }

        // If multiple family members, validate all
        for (let i = 0; i < familyMembers.length; i++) {
            const member = familyMembers[i];
            const isDobValid = dobRegex.test(member.dob) && new Date(member.dob) <= new Date();

            // Check missing values (excluding phone)
            if (
                Object.entries(member).some(
                    ([key, value]) =>
                        key !== "mobile_number" &&
                        (value === null ||
                            value === undefined ||
                            value.toString().trim() === "")
                )
            ) {
                msg += `Missing values in family member at index ${i}: ${JSON.stringify(
                    member
                )}`;
            }

            // Validate phone number separately

            if (!isValidPhone(member.mobile_number)) {
                msg += "Invalid phone number.\n";
            }

            if (!isDobValid) {
                msg += "Invalid DOB format. Please use MM/DD/YYYY.\n";
            }
            return msg || null;
        }

        return null; // All validations passed
    };


    const ButtonGroup = ({
        isSubmitted,
        currentPage,
        handleEdit,
        handleNext,
        handleFormSubmit,
        handleAddMember,
    }) => {
        const buttonClass =
            "px-6 py-3 bg-sky-600 text-white rounded-lg shadow-md hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-opacity-50 transition-all";

        const isFamilyConsentPage = currentPage === 3;

        return (
            <div className="flex flex-col items-end gap-2 p-5">
                {isFamilyConsentPage ? (
                    <>
                        <button
                            type="button"
                            onClick={handleAddMember}
                            className="px-4 py-3 bg-white text-sky-600 border border-sky-600 rounded-lg shadow-md hover:bg-sky-50 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-opacity-50 transition-all flex items-center"
                        >
                            <FaPlus className="mr-2 h-4 w-4" />
                            Add New Family Member
                        </button>
                        <button
                            type="button"
                            onClick={handleFormSubmit}
                            className={buttonClass}
                        >
                            <i className="fas fa-user-plus mr-2"></i> Submit
                        </button>
                    </>
                ) : (
                    <button
                        type="button"
                        onClick={handleNext}
                        className={buttonClass}
                        id="next"
                    >
                        <i className="fas fa-arrow-right mr-2"></i> Next
                    </button>
                )}
            </div>
        );
    };

    const handleAddMember = () => {
        const lastMember =
            PatientRegistrationFormData.familyMembers[
            PatientRegistrationFormData.familyMembers.length - 1
            ];
        const filledFields = [
            lastMember.name,
            lastMember.relationship,
            lastMember.dob,
            lastMember.mobile_number,
        ].filter((field) => field !== "" && field !== null);

        console.log(filledFields);
        // Check for phone number validity
        const parsedPhone = parsePhoneNumberFromString(lastMember.mobile_number, "US");
        const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
        const isPhoneValid =
            lastMember.mobile_number && parsedPhone && parsedPhone.isValid();
        const isDobValid = dobRegex.test(lastMember.dob) && new Date(lastMember.dob) <= new Date();
        // If only one field is filled or the phone number is invalid, show a single alert
        if (filledFields.length < 4 || !isPhoneValid || !isDobValid) {
            let alertMessage =
                "Please fill in all fields for the current family member before adding another.";
            if (!isPhoneValid || !isDobValid) {
                alertMessage += " Additionally, please provide:";

                if (!isPhoneValid) {
                    alertMessage += " a valid phone number";
                }

                if (!isPhoneValid && !isDobValid) {
                    alertMessage += " and";
                }

                if (!isDobValid) {
                    alertMessage += " a valid date of birth";
                }

                alertMessage += ".";
            }
            Swal.fire({
                title: "Missing/Invalid Fields",
                text: alertMessage,
                icon: "warning",
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });
            return; // Prevent adding a new member
        }
        setPatientRegistrationFormData({
            ...PatientRegistrationFormData,
            familyMembers: [
                ...PatientRegistrationFormData.familyMembers,
                { name: "", relationship: "", dob: "", mobile_number: "" },
            ],
        });
    };


    const handleRemoveFamilyMember = (index) => {
        if (index === 0) {
            setPatientRegistrationFormData((prevData) => ({
                ...prevData,
                familyMembers: [
                    { name: '', relationship: '', dob: '', mobile_number: '' } // Reset all fields for the first family member
                ],
            }));
            return;
        }
        const updatedFamilyMembers = PatientRegistrationFormData.familyMembers.filter((_, i) => i !== index);
        setPatientRegistrationFormData({
            ...PatientRegistrationFormData,
            familyMembers: updatedFamilyMembers
        });
    };

    useEffect(() => {
        // Set the title based on the current page
        setPageTitle('Demographics');
    }, [setPageTitle]); // Run this effect whenever `currentPage` or `setTitle` changes

    const handleInputChange = (e) => {
        const { id, type, checked, value } = e.target;
        setPatientRegistrationFormData((prev) => ({
            ...prev,
            [id]: type === "checkbox" ? checked : value,
        }));
    };

    const validatePage1 = () => {
        // Define validation patterns
        const PATTERNS = {
            ssn: /^\d{3}-\d{2}-\d{4}$|^\d{9}$/,
            email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            phone: (value, country = "US") => {
                const parsed = parsePhoneNumberFromString(value, country);
                return parsed?.isValid() || false;
            },
        };

        // Define required fields
        const REQUIRED_FIELDS = [
            { field: "firstName", label: "First Name" },
            { field: "lastName", label: "Last Name" },
            { field: "address", label: "Address" },
            { field: "city", label: "City" },
            { field: "state", label: "State" },
            { field: "zip", label: "Zip" },
            { field: "cellphone", label: "Cell Phone" },
            { field: "dob", label: "DOB" },
            { field: "gender", label: "Gender" },
        ];

        // Reset invalid fields
        setInvalidFields([]);
        const invalidFields = [];

        // Validate required fields
        REQUIRED_FIELDS.forEach(({ field, label }) => {
            const value = PatientRegistrationFormData[field];
            if (!String(value || "").trim()) {
                console.log('label', label)
                invalidFields.push(label);
            }
        });

        // Emergency fields validation
        const { cellphone, ssn, dob } = PatientRegistrationFormData;

        if (dob) {
            const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
            if (!dobRegex.test(dob)) {
                invalidFields.push("DOB");
            } else {
                const [month, day, year] = dob.split("/").map(Number);
                const dobDate = new Date(year, month - 1, day);
                const today = new Date();
                const minDate = new Date(today.getFullYear() - 125, today.getMonth(), today.getDate());

                if (dobDate > today || dobDate < minDate) {
                    invalidFields.push("DOB");
                }
            }
        }

        // Validate cell phone
        if (!PATTERNS.phone(cellphone)) {
            invalidFields.push("Cell Phone");
        }

        // Validate SSN
        if (ssn && !PATTERNS.ssn.test(ssn)) {
            invalidFields.push("SSN");
        }

        // If there are invalid fields, show an alert
        if (invalidFields.length > 0) {
            setInvalidFields(invalidFields);

            Swal.fire({
                title: "Missing or Invalid Fields",
                text: `Please fill out or correct the following fields:\n- ${invalidFields.join("\n- ")}`,
                icon: "warning",
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });

            return false; // Indicate invalid form
        }
        return true; // Indicate valid form
    };

    const validatePage2 = () => {
        const PATTERNS = {
            ssn: /^\d{3}-\d{2}-\d{4}$|^\d{9}$/,
            email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            phone: (value, country = "US") => {
                const parsed = parsePhoneNumberFromString(value, country);
                return parsed?.isValid() || false;
            },
        };

        const REQUIRED_FIELDS = [
            // { field: "email", label: "Email" },
            { field: "familyDoctor", label: "Family Doctor" },
            { field: "referredBy", label: "Referred By" }
        ];

        // Reset invalid fields
        setInvalidFields([]);
        const invalidFields = [];

        // Validate required fields
        REQUIRED_FIELDS.forEach(({ field, label }) => {
            if (!PatientRegistrationFormData[field]?.trim()) {
                invalidFields.push(label);
            }
        });


        // Emergency fields validation
        const { portal, email, emergencyPhone, emergencyName, emergencyRelationship } = PatientRegistrationFormData;
        const emergencyFields = [
            { value: emergencyName, label: "Emergency Name" },
            { value: emergencyRelationship, label: "Emergency Relationship" },
            { value: emergencyPhone, label: "Emergency Phone" },
        ];

        const filledEmergencyFields = emergencyFields.filter(({ value }) => value?.trim()).length;
        if (filledEmergencyFields > 0 && filledEmergencyFields < emergencyFields.length) {
            emergencyFields.forEach(({ value, label }) => {
                if (!value?.trim()) invalidFields.push(label);
            });
        }

        // Validate Emergency Phone
        if (emergencyPhone && !PATTERNS.phone(emergencyPhone)) {
            invalidFields.push("Emergency Phone");
        }

        // Validate email
        if (portal === true && (!email || !PATTERNS.email.test(email))) {
            invalidFields.push("Email");
        } else if (email && !PATTERNS.email.test(email)) {
            invalidFields.push("Email");
        }

        if (invalidFields.length > 0) {
            setInvalidFields(invalidFields);

            Swal.fire({
                title: "Missing or Invalid Fields",
                text: `Please fill out or correct the following fields:\n- ${invalidFields.join("\n- ")}`,
                icon: "warning",
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });

            return false; // Indicate invalid form
        }
        return true; // Indicate valid form

    }

    const validatePage3 = () => {
        setInvalidFields([]);
        const invalidFields = [];
        const { familyMembers } = PatientRegistrationFormData;

        const result = validateFamilyMembers(familyMembers);
        if (result) {
            invalidFields.push(result);
        }

        if (invalidFields.length > 0) {
            setInvalidFields(invalidFields);

            Swal.fire({
                title: "Missing or Invalid Fields",
                text: `Please fill out or correct the following fields:\n- ${invalidFields.join("\n- ")}`,
                icon: "warning",
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });

            return false; // Indicate invalid form
        }
        return true; // Indicate valid form
    }

    const handleEdit = (e) => {
        setCurrentPage(1);
        setIsSubmitted(false);
    }

    const update_database = async () => {
        const response = await fetch(`${config.API_BASE_URL}/update_db`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: config.accessToken || "",
            },
            body: JSON.stringify({
                form: PatientRegistrationFormData
            }),
        });
        if (response.ok) {
            console.log("Demographics updated successfully.");
            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Demographics updated successfully.",
                confirmButtonText: "Close",
                allowOutsideClick: false,
            }).then(() => {
                navigate("/form-submission-success", { state: { openedViaLogin: true } });
            });
        }
        else {
            showAlertAndNavigate(
                "warning",
                "Unauthorized",
                "Your session expired. Redirecting to login...",
                config.token
            );

        }
    }

    // Main Upload Function - Updated handleFormSubmit section
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (currentPage === 3) {
            const validate = validateForm(currentPage);
            if (!validate) {
                return;
            }
        }


        try {
            // Update database
            await update_database();

        } catch (error) {
            console.error('Form submission error:', error);

        } finally {
            setFileUpload(false);
        }
    };

    const validateForm = (page) => {
        switch (page) {
            case 1:
                return validatePage1()
            case 2:
                return validatePage2();

            case 3:
                return validatePage3();
            default:
                return false;
        }
    };

    const handleNext = async (e) => {
        try {
            e.preventDefault();
            setNextLoader(true);
            console.log("currentPage before validation:", currentPage);

            if (!validateForm(currentPage)) {
                console.log("Validation failed");
                setNextLoader(false);
                return;
            }

            // Use functional update to ensure you get the latest state
            setCurrentPage((prev) => {
                console.log("Incrementing currentPage:", prev + 1);
                return prev + 1;
            });
            setNextLoader(false);
        } catch (error) {
            console.error("Error in handleNext:", error);
        }
        finally {
            setNextLoader(false);
        }
    };

    const handleBackClick = () => {
        if (currentPage === 1) {
            return;
        }
        setCurrentPage(currentPage - 1);  // Decrement the current page for pages 2, 3, 4, etc.
    };

    return (
        <div className="min-h-screen w-full flex justify-center bg-gray-50 py-4 px-3 sm:px-4 lg:px-6">
            <div className="w-full max-w-4xl bg-white rounded-lg shadow-sm mx-auto">
                {isLoading4 && (
                    <Writing />
                )}
                {nextLoader && (
                    <NextBtnLoader />
                )}
                {fileUpload && (
                    <Rocket />
                )}
                <form className="p-4 sm:p-6 lg:p-8 bg-white">
                    {currentPage > 1 && (
                        <Back onClick={handleBackClick} />
                    )}
                    {/* Page 1 */}
                    {currentPage === 1 && (
                        <div className="space-y-6">
                            <div>

                                <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-center sm:justify-between mb-6">
                                    <Logo
                                        src={config.practice?.toLowerCase() === 'rsi' ? logo : segLogo}
                                        className="w-16 h-auto sm:w-20"
                                    />
                                    <Head title={pageTitle} />
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6">
                                    {[
                                        {
                                            id: "firstName",
                                            label: "First Name",
                                            required: true,
                                        },
                                        {
                                            id: "lastName",
                                            label: "Last Name",
                                            required: true,
                                        }
                                    ].map(({ id, label, required }) => (
                                        <FormInput
                                            key={id}
                                            id={id}
                                            label={label}
                                            type="text"
                                            disabled={nextLoader}
                                            value={PatientRegistrationFormData[id]}
                                            onChange={handleInputChange}
                                            invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                                            required={required}
                                        />
                                    ))}
                                </div>

                                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {/* DOB */}
                                    <DobInput
                                        value={PatientRegistrationFormData.dob}
                                        onChange={(val) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                dob: val || "",
                                            }))
                                        }
                                        invalid={invalidFields.includes("DOB")}
                                    />

                                    <div className="flex items-center space-x-2">
                                        <SelectInput
                                            id="gender"
                                            label="Gender *"
                                            options={genderOptions}
                                            value={PatientRegistrationFormData.gender}
                                            onChange={(e) =>
                                                setPatientRegistrationFormData((prev) => ({
                                                    ...prev,
                                                    gender: e.target.value,
                                                }))
                                            }
                                            disabled={nextLoader}
                                            invalid={invalidFields.includes("Gender") && !PatientRegistrationFormData.gender}
                                            errorMessage="Please select a gender."
                                        />

                                    </div>
                                </div>

                                {/* Address */}
                                <TextInput
                                    id="address"
                                    label="Address"
                                    required
                                    value={PatientRegistrationFormData.address}
                                    onChange={handleInputChange}
                                    disabled={nextLoader}
                                    invalid={invalidFields.includes("Address") && !PatientRegistrationFormData.address}
                                />

                                <div className="mb-4 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">

                                    <div className="flex flex-col">
                                        <FormInput
                                            id="zip"
                                            label="Zip"
                                            type="text"
                                            disabled={nextLoader}
                                            value={PatientRegistrationFormData["zip"]}
                                            onChange={handleInputChange}
                                            invalid={invalidFields.includes("zip") && !PatientRegistrationFormData["zip"]}
                                            required={true}
                                            onZipSearch={handleZipSearch}
                                        />

                                        {!nextLoader && (
                                            <p className="text-sm text-muted-foreground mt-1">
                                                City and State can be filled by using Zip
                                            </p>
                                        )}
                                    </div>


                                    <FormInput
                                        key="city"
                                        id="city"
                                        label="City"
                                        type="text"
                                        disabled={true}
                                        value={PatientRegistrationFormData["city"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("City") && !PatientRegistrationFormData["city"]}
                                        required={true}
                                    />

                                    <FormInput
                                        key="state"
                                        id="state"
                                        label="State"
                                        type="text"
                                        disabled={true}
                                        value={PatientRegistrationFormData["state"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("State") && !PatientRegistrationFormData["state"]}
                                        required={true}
                                    />
                                </div>

                                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {/* cellphone */}
                                    <FormInput
                                        key="cellphone"
                                        id="cellphone"
                                        label="Cell Phone"
                                        type="number"
                                        disabled={nextLoader}
                                        value={PatientRegistrationFormData["cellphone"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Cell Phone") && !PatientRegistrationFormData["cellphone"]}
                                        required={true}
                                    />
                                    {/* reminderPhone */}
                                    <DynamicCheckbox
                                        label="Consent to Text"
                                        fieldName="consentToText"
                                        id="consentToText"
                                        isChecked={PatientRegistrationFormData.consentToText}
                                        onChange={handleInputChange}
                                        isDisabled={nextLoader}
                                        showError={invalidFields.includes("consentToText")}
                                    />

                                </div>

                                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {/* Preferred Language */}
                                    <SelectInput
                                        id="preferredLanguage"
                                        label="Preferred Language"
                                        options={languageOptions}
                                        value={PatientRegistrationFormData.language}
                                        onChange={(e) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                language: e.target.value,
                                            }))
                                        }
                                        disabled={nextLoader}
                                        invalid={invalidFields.includes("preferredLanguage") && !PatientRegistrationFormData.language}
                                        errorMessage="Please select a language."
                                    />

                                    {/* ssn */}

                                    <FormInput
                                        key="ssn"
                                        id="ssn"
                                        label="Social Security Number"
                                        type="number"
                                        disabled={nextLoader}
                                        value={PatientRegistrationFormData["ssn"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("SSN")}
                                        required={false}
                                    />
                                </div>

                                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <SelectInput
                                        id="ethnicity"
                                        label="Ethnicity"
                                        options={ethnicityOptions}
                                        value={PatientRegistrationFormData.ethnicity}
                                        onChange={(e) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                ethnicity: e.target.value,
                                            }))
                                        }
                                        disabled={nextLoader}
                                        invalid={invalidFields.includes("ethnicity")}
                                    />

                                    <SelectInput
                                        id="race"
                                        label="Race"
                                        options={raceOptions}
                                        value={PatientRegistrationFormData.race}
                                        onChange={(e) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                race: e.target.value,
                                            }))
                                        }
                                        disabled={nextLoader}
                                        invalid={invalidFields.includes("race")}
                                        errorMessage="Please select a race."
                                    />
                                </div>

                            </div>
                        </div>
                    )
                    }
                    {currentPage === 2 && (
                        <div className="space-y-6">
                            <div>

                                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {/* referred by */}

                                    <FormInput
                                        key="referredBy"
                                        id="referredBy"
                                        label="Referred By"
                                        type="text"
                                        disabled={nextLoader}
                                        value={PatientRegistrationFormData["referredBy"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Referred By")}
                                        required={true}
                                    />

                                    {/* family doctor */}
                                    <FormInput
                                        key="familyDoctor"
                                        id="familyDoctor"
                                        label="Family Doctor"
                                        type="text"
                                        disabled={nextLoader}
                                        value={PatientRegistrationFormData["familyDoctor"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Family Doctor")}
                                        required={true}
                                    />

                                </div>

                                <TextInput
                                    id="email"
                                    label="Email"
                                    required
                                    value={PatientRegistrationFormData.email}
                                    onChange={handleInputChange}
                                    disabled={nextLoader}
                                    invalid={invalidFields.includes("Email") && !PatientRegistrationFormData.email}
                                />

                                {/* Portal */}
                                <MedicalPortalAccess
                                    portalValue={PatientRegistrationFormData.portal}
                                    onChange={handlePortalChange}
                                    isDisabled={nextLoader}
                                />

                                <div className="border-t-4 border-b-4 border-gray-300 p-4">
                                    {/* Emergency Contact Information Heading */}
                                    <p className="text-lg font-semibold text-center text-black">
                                        Emergency Contact Information
                                    </p>
                                </div>


                                <div className="mb-4 mt-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {/* Name */}

                                    <FormInput
                                        key="emergencyName"
                                        id="emergencyName"
                                        label="Emergency Name"
                                        type="text"
                                        disabled={nextLoader}
                                        value={PatientRegistrationFormData["emergencyName"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Emergency Name")}
                                        required={false}
                                    />

                                    {/* relationship */}
                                    <SelectInput
                                        id="emergencyRelationship"
                                        label="Emergency Relationship"
                                        options={emergencyRelationshipOptions}
                                        value={PatientRegistrationFormData.emergencyRelationship}
                                        onChange={(e) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                emergencyRelationship: e.target.value,
                                            }))
                                        }
                                        disabled={nextLoader}
                                        invalid={invalidFields.includes("Emergency Relationship")}
                                        errorMessage="Please select a emergency relationship."
                                    />
                                </div>

                                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <FormInput
                                        key="emergencyPhone"
                                        id="emergencyPhone"
                                        label="Emergency Phone"
                                        type="number"
                                        disabled={isSubmitted}
                                        value={PatientRegistrationFormData["emergencyPhone"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Emergency Phone")}
                                        required={false}
                                    />
                                </div>

                                <div>
                                    {invalidFields.includes('emergencyFields') && (
                                        <p style={{ color: 'red' }}>Fill out all the fields in the emergency contact information!</p>
                                    )}
                                </div>

                            </div>
                        </div>
                    )
                    }
                    {currentPage === 3 && (
                        <div className="space-y-6">
                            <div>
                                <div>
                                    {/* Emergency Contact Information Heading */}
                                    <p className="text-lg font-semibold text-center text-black">
                                        Family Member Consent
                                    </p>
                                </div>

                                <div className="text-black">
                                    <Paragraph>
                                        With your permission, Retina Specialty Institute may release your protected health information to a family member, or another person involved in your care or payment for your care.
                                    </Paragraph>
                                    <Paragraph>
                                        Please identify the person or persons who are involved in your care or the payment of your care that you can authorize to receive your protected health information. This may include your spouse, parent, siblings, children, close friend, or guardian. Please list below:
                                    </Paragraph>
                                </div>

                                <div className="hidden lg:grid grid-cols-[1fr_1fr_1fr_1fr_40px] gap-4 mb-2 font-medium text-sm text-gray-700 px-2">
                                    <div>Name</div>
                                    <div>Relationship</div>
                                    <div>Date of Birth</div>
                                    <div>Phone</div>
                                    <div></div>
                                </div>

                                {/* Family Members */}
                                <div className="space-y-4">
                                    {PatientRegistrationFormData.familyMembers.map((member, index) => (
                                        <div
                                            key={index}
                                            className="bg-gray-50 p-4 rounded-lg border border-gray-200"
                                        >
                                            {/* Mobile/Tablet: Stacked Layout */}
                                            <div className="lg:hidden space-y-4">
                                                <div>
                                                    <label className="text-xs font-medium text-gray-600 mb-1 block">Name</label>
                                                    <input
                                                        value={member.name}
                                                        onChange={(e) => handleFamilyContentChange(index, 'name', e.target.value)}
                                                        className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                                                        placeholder="Full Name"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="text-xs font-medium text-gray-600 mb-1 block">Relationship</label>
                                                    <input
                                                        value={member.relationship}
                                                        onChange={(e) => handleFamilyContentChange(index, 'relationship', e.target.value)}
                                                        className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                                                        placeholder="Relationship"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="text-xs font-medium text-gray-600 mb-1 block">Date of Birth</label>
                                                    <input
                                                        type="text"
                                                        value={member.dob}
                                                        onChange={(e) => handleFamilyContentChange(index, 'dob', e.target.value)}
                                                        placeholder="MM/DD/YYYY"
                                                        className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="text-xs font-medium text-gray-600 mb-1 block">Phone</label>
                                                    <input
                                                        type="tel"
                                                        value={member.mobile_number}
                                                        onChange={(e) => handleFamilyContentChange(index, 'mobile_number', e.target.value)}
                                                        className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                                                        placeholder="Phone Number"
                                                    />
                                                </div>
                                                {!isFamilyMemberEmpty(member) && (
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveFamilyMember(index)}
                                                        className="flex items-center gap-2 text-red-600 hover:text-red-700 text-sm font-medium"
                                                    >
                                                        <FaTrash className="w-5 h-5" />
                                                        Remove
                                                    </button>
                                                )}
                                            </div>

                                            {/* Desktop: Grid Layout */}
                                            <div className="hidden lg:grid grid-cols-[1fr_1fr_1fr_1fr_auto] gap-4 items-center">
                                                <input
                                                    value={member.name}
                                                    onChange={(e) => handleFamilyContentChange(index, 'name', e.target.value)}
                                                    className="px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                                                    placeholder="Full Name"
                                                />
                                                <input
                                                    value={member.relationship}
                                                    onChange={(e) => handleFamilyContentChange(index, 'relationship', e.target.value)}
                                                    className="px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                                                    placeholder="Relationship"
                                                />
                                                <input
                                                    type="text"
                                                    value={member.dob}
                                                    onChange={(e) => handleFamilyContentChange(index, 'dob', e.target.value)}
                                                    placeholder="MM/DD/YYYY"
                                                    className="px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                                                />
                                                <input
                                                    type="tel"
                                                    value={member.mobile_number}
                                                    onChange={(e) => handleFamilyContentChange(index, 'mobile_number', e.target.value)}
                                                    className="px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                                                    placeholder="Phone"
                                                />
                                                {!isFamilyMemberEmpty(member) && (
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveFamilyMember(index)}
                                                        className="text-red-600 hover:text-red-700 p-1 justify-self-center"
                                                    >
                                                        <FaTrash className="w-5 h-5" />
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                    )
                    }
                    <ButtonGroup
                        isSubmitted={isSubmitted}
                        currentPage={currentPage}
                        handleEdit={handleEdit}
                        handleNext={handleNext}
                        handleFormSubmit={handleFormSubmit}
                        handleAddMember={handleAddMember}
                        validateForm={validateForm}
                    />
                </form >
            </div >
        </div>
    );
};

export default PatientRegistrationPageForm;



